module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "pro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("We walk on fire or air, so Daddy liked to say. Basement floors too hot to touch. Steaming green lawns in the dead of winter. Sinkholes, quick and sudden, plunging open at your feet.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Where the hollowed out ground didn’t burn, it collapsed or sank. Here is what’s known as the Anthracite Coal Region of Pennsylvania, fed by the largest vein of anthracite coal in the world. That coal was blasted, hauled, breathed, and swallowed by our daddies’ daddies and by theirs before them. And when those mines shut down, those snaking, black tunnels were left to flood—to shift. They were left to burn.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Burning more than coal, I’d tell you. When I was still curled and wet in my ma’s belly, those mines burned my memory. Burned me with the want to see them for myself. To enter their long, sloping darkness and know what my daddy went through before whatever it was got broke inside him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’m not saying I knew what I’d uncover when I crawled and scraped my way into that narrow monkey shaft. I’m not saying I knew the secrets I freed from there would change us permanently for worse or better. I’m just saying that sometimes what we seek is something we hope, with all our blood and bone, we’ll never find.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 75
// module chunks = 0